import {removeCookie} from '../../other/utils/cookie.js';

const actions = {
    async clearRouters({commit, state}) {
        return new Promise(resolve => {
            commit('CLEAR_ROUTERS', {
                whole: state.permission.routers,
                added: state.permission.addRouters
            });
            resolve();
        })
    },
    async clearVisitedViews({dispatch, commit}) {
        await dispatch('clearRouters');
        commit('CLEAR_VISITED_VIEWS');
    },
    // 登出
    async logOut({dispatch, commit, state}) {
        await dispatch('clearRouters');
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            removeCookie("token");
            resolve();
        });
    },
}
export default actions;



// WEBPACK FOOTER //
// ./src/other/store/actions.js